import { TOGGLE_SHOW_GUIDES } from 'modules/v2/editor/store/constants';

export const toggleShowGuides = (showGuides = false) => ({
  type: TOGGLE_SHOW_GUIDES,
  payload: {
    showGuides,
  },
});
